
<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Venue',

    metaInfo: { title: 'Venue' },

    extends: View,

    mixins: [
      LoadSections([
        'venue',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'venue',
      },
    },
  }
</script>
